/* eslint-disable */
export default {
  _title_christmas_lights_math: 'title_christmas_lights_math',
  _title_christmas_lights: 'title_christmas_lights',
  _play_again: 'play_again',
}